import React from "react";
import { useLocation } from "react-router-dom";
import PageMeta from "./PageMeta";

const SUFFIX = " | MediaCrypto";

const STATIC_META = {
  "/news": {
    title: "Crypto News, Guides & Analysis" + SUFFIX,
    description: "Latest cryptocurrency news, price predictions, beginner guides and market analysis from the MediaCrypto editorial team.",
  },
  "/coins": {
    title: "Cryptocurrency Prices & Market Data" + SUFFIX,
    description: "Live prices, charts and market data for top cryptocurrencies, with news and analysis for each coin.",
  },
  "/categories": {
    title: "News Categories" + SUFFIX,
    description: "Browse MediaCrypto articles by topic: Bitcoin, Ethereum, altcoins, market analysis, regulation and more.",
  },
  "/tools/dca-calculator": {
    title: "DCA Calculator for Crypto" + SUFFIX,
    description: "Calculate how dollar-cost averaging into Bitcoin or any crypto would have performed with this free DCA calculator.",
  },
  "/tools/whale-tracker": {
    title: "Crypto Whale Tracker" + SUFFIX,
    description: "Follow large cryptocurrency transactions and whale wallet movements with this free whale tracker.",
  },
  "/tools/profit-calculator": {
    title: "Crypto Profit Calculator" + SUFFIX,
    description: "Work out your crypto gains, losses and ROI before and after fees with this free profit calculator.",
  },
  "/tools/coin-compare": {
    title: "Compare Cryptocurrencies Side by Side" + SUFFIX,
    description: "Compare price, market cap, supply and performance of two cryptocurrencies side by side.",
  },
  "/tools/halving-countdown": {
    title: "Bitcoin Halving Countdown" + SUFFIX,
    description: "Live countdown to the next Bitcoin halving, with block height, date estimate and what a halving means.",
  },
  "/tools/wallet-scanner": {
    title: "Crypto Wallet Scanner" + SUFFIX,
    description: "Scan a crypto wallet address for balances and activity with this free wallet scanner tool.",
  },
  "/forex": {
    title: "Live Forex Rates & Currency Pairs" + SUFFIX,
    description: "Live exchange rates for major currency pairs, with news and analysis on how forex moves affect crypto.",
  },
  "/stocks": {
    title: "Stock Market Data & Prices" + SUFFIX,
    description: "Track major stocks and indices alongside crypto, with news and analysis from MediaCrypto.",
  },
  "/market": {
    title: "Crypto Market Overview" + SUFFIX,
    description: "Global crypto market overview: total market cap, Bitcoin dominance, top movers and sentiment.",
  },
  "/calendar": {
    title: "Crypto & Economic Calendar" + SUFFIX,
    description: "Upcoming crypto events, token unlocks and macro releases that can move the market.",
  },
  "/community": {
    title: "Crypto Community: Posts & Predictions" + SUFFIX,
    description: "Posts from traders, builders and researchers, with predictions tracked publicly on MediaCrypto.",
  },
  "/contact": {
    title: "Contact MediaCrypto",
    description: "Get in touch with the MediaCrypto team for editorial, partnership and general enquiries.",
  },
  "/privacy": {
    title: "Privacy Policy" + SUFFIX,
    description: "How MediaCrypto collects, uses and protects your data.",
  },
  "/careers": {
    title: "Careers at MediaCrypto",
    description: "Open roles and ways to contribute to MediaCrypto, an independent crypto media publication.",
  },
  "/projects": {
    title: "Crypto Projects Directory" + SUFFIX,
    description: "Explore crypto projects, with research and coverage from the MediaCrypto team.",
  },
  "/trading-simulator": {
    title: "Crypto Trading Simulator" + SUFFIX,
    description: "Practice crypto trading with virtual funds and leverage, no real money at risk.",
  },
  "/about": {
    title: "About MediaCrypto: Independent Crypto Media",
    description: "MediaCrypto is an independent crypto media publication covering news, market analysis, guides and free tools.",
  },
  "/editorial-policy": {
    title: "Editorial Policy" + SUFFIX,
    description: "How MediaCrypto researches, writes, corrects and updates its articles, and how we handle sponsored content.",
  },
  "/about/research-desk": {
    title: "Research Desk" + SUFFIX,
    description: "Meet the MediaCrypto Research Desk and see how our data-driven crypto analysis is produced.",
  },
};

const WORDS = { nfts: "NFTs", nft: "NFT", defi: "DeFi", ai: "AI", btc: "BTC", eth: "ETH" };

function titleCaseSlug(slug) {
  return slug
    .split("-")
    .filter(Boolean)
    .map((w) => WORDS[w] || w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export default function RouteMeta() {
  const { pathname } = useLocation();
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;

  let meta = STATIC_META[path];

  if (!meta && path.startsWith("/categories/")) {
    const name = titleCaseSlug(path.slice("/categories/".length));
    if (name) {
      meta = {
        title: name + " News & Analysis" + SUFFIX,
        description: "Latest " + name + " articles, guides and analysis from the MediaCrypto editorial team.",
      };
    }
  }

  if (!meta) return null;
  return <PageMeta title={meta.title} description={meta.description} path={path} />;
}